var render = function render(_c,_vm){return _c('div',{staticClass:"v-card__content"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }